export default __webpack_public_path__ + "static/media/imagePickAndPackContentFive.986240be.png";